module.exports = __webpack_public_path__ + "static/media/Famine.673a9426.jpg";